import actionTypes from '../constants/action-types';
import getFocusedElement from '../selectors/focused-element';
import synchronizeElement from '../actions/synchronize-element';
import getLiveElement from '../accessors/get-live-element';
import getStaticElement from '../accessors/get-static-element';
import hdrm from '../../hdrm';

const blurFocusedElement = (store) => (next) => (action) => {
  const { type, payload } = action;

  if (type !== actionTypes.BLUR_FOCUSED_ELEMENT) {
    next(action);

    return;
  }

  const state = store.getState();
  const focusedElementId = getFocusedElement(state);
  const oldElement = getStaticElement(focusedElementId);
  const liveElement = getLiveElement(focusedElementId);

  if (payload.options.preserveFocusedTextElement) {
    hdrm.helpers.preserveTextElement(liveElement);
  }

  const newElement = hdrm.instance.driver.transformToStatic(liveElement);

  /*
   * Originaly it was an `innerHTML` comparison.
   * The change was caused by this ticket https://github.com/yola/production/issues/6084.
   *
   * It turned out that ws-text-formatting functionality relies on this part of code. We should
   * consider elements that can change their attributes so `innerHTML` can't show the difference.
   *
   * However, ws-text-formatting should use SDK view operations to update the static DOM.
   * */
  if (newElement.outerHTML === oldElement.outerHTML) {
    /*
     * when contents are identical we still need call synchronizeElement to update references on static nodes
     * but without triggering history
     * */
    hdrm.instance.driver.synchronizeElement(liveElement);
    next(action);

    return;
  }

  store.dispatch(synchronizeElement(focusedElementId));

  next(action);
};

export default blurFocusedElement;
